module.exports = __webpack_public_path__ + "media/images/background-team-1e3a80e0.jpg";